var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11177 15.5415C8.30603 15.7318 8.55328 15.8355 8.84467 15.8355C9.42745 15.8355 9.89545 15.3859 9.89545 14.8151C9.89545 14.5297 9.77183 14.2703 9.56874 14.0714L3.38767 8.1562L9.56874 2.25832C9.77183 2.05941 9.89545 1.79133 9.89545 1.51459C9.89545 0.943832 9.42745 0.494141 8.84467 0.494141C8.55328 0.494141 8.30603 0.597916 8.11177 0.78817L1.24196 7.36059C0.994715 7.58543 0.879924 7.86217 0.871094 8.16484C0.871094 8.46752 0.994715 8.72696 1.24196 8.96045L8.11177 15.5415Z",
    fill: "#44494D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBackIcon);
export default __webpack_public_path__ + "static/media/calendar-back-icon.a859fe15f63bd162123460cc311d2658.svg";
export { ForwardRef as ReactComponent };